import React, { useState } from 'react';
import { Button, Navbar, Sidebar } from 'flowbite-react';
import { Outlet, useNavigate } from 'react-router';
import { HiChartPie, HiMenu, HiArrowLeft } from 'react-icons/hi';
import { useAuth } from '../../context/authContext';
import { routes } from '../../routes';

// Tailwind CSS is always mobile first
// The first property is the mobile breakpoint, in this case flex-col
// sm: >640px
// md: >768px
// lg: >1024px
// xl: >1280px
// 2xl: >1536px

const DashboardLayout = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <div
            className="flex flex-col sm:flex-col md:flex-col lg:flex-row h-screen"
            style={{ backgroundColor: '#F9FAFC' }}>
            <Navbar className="lg:hidden bg-white shadow">
                <Navbar.Brand href="#">
                    <span className="self-center whitespace-nowrap text-xl font-semibold">
                        Care11 | Códigos postales
                    </span>
                </Navbar.Brand>
                <Button
                    color="dark"
                    onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                    className="p-2">
                    <HiMenu className="text-lg" />
                </Button>
            </Navbar>

            <div className="hidden lg:flex h-full">
                <Care11Sidebar />
            </div>

            <div
                className={`flex-1 mt-2 rounded-tl-2xl overflow-hidden bg-white shadow ${
                    isSidebarOpen ? 'h-[calc(100%-4rem)]' : 'h-full'
                }`}>
                <Outlet />
            </div>
            {/* Sidebar Dropdown for Mobile */}
            {isSidebarOpen && (
                <div className="lg:hidden bg-white shadow-md absolute top-16 left-0 w-full z-50">
                    <Care11Sidebar />
                </div>
            )}
        </div>
    );
};

const Care11Sidebar = () => {
    const navigator = useNavigate();
    const { logout } = useAuth();

    const _logout = () => {
        logout();
        navigator(routes.LOGIN, { replace: true });
    };

    return (
        <Sidebar aria-label="Mobile Sidebar">
            <Sidebar.Items>
                <Sidebar.ItemGroup>
                    <Sidebar.Item icon={HiChartPie}>Panel de control</Sidebar.Item>
                    <Sidebar.Item href="#" onClick={_logout} icon={HiArrowLeft}>
                        Cerrar sesión
                    </Sidebar.Item>
                </Sidebar.ItemGroup>
            </Sidebar.Items>
        </Sidebar>
    );
};

export default DashboardLayout;
